import React, {useRef} from 'react';
import {motion, useScroll, useTransform} from 'framer-motion';

const ParallaxImage = ({src, speed = 0.3, className = '', children}) => {
    const containerRef = useRef(null);

    const {scrollYProgress} = useScroll({
        target: containerRef,
        offset: ["start end", "end start"]  // Активация по видимости, как в Wix
    });

    // Сдвиг y: вверх при скролле вниз (negative, амплитуда 20% * speed — как в Wix, не агрессивно)
    const y = useTransform(scrollYProgress, [0, 1], ["0%", `-${20 * speed}%`]);

    // Новый: Лёгкий zoom-out (scale от 1.2 к 1.0) — предотвращает пустоты, раскрывает низ изображения
    const scale = useTransform(scrollYProgress, [0, 1], [1.4, 1.2]);

    return (
        <div
            ref={containerRef}
            className={`relative w-full overflow-hidden ${className}`}
        >
            <motion.div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(${src})`,
                    backgroundAttachment: 'fixed',  // Базовый фикс, как в Wix (для совместимости)
                    y: y,      // Сдвиг для параллакса
                    scale: scale,  // Zoom-out для no empty space
                    transformOrigin: 'center top',  // Фиксация сверху, раскрытие снизу
                    willChange: 'transform'  // Оптимизация
                }}
            />
            {children}
        </div>
    );
};

export default ParallaxImage;